import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { format } from 'date-fns'


@Component({
  selector: 'modal-datepicker',
  templateUrl: './modal-datepicker.component.html',
  styleUrls: ['./modal-datepicker.component.scss'],
})
export class ModalDatePickerComponent implements OnInit {

  dateChosen: any;
  enableTime: boolean;

  flatPickrOptions = null;


  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    this.flatPickrOptions = {
      enableTime: this.enableTime,
      altFormat: this.enableTime ? 'd-m-Y H:i' : 'd-m-Y',
      dateFormat: this.enableTime ? 'Y-m-d H:i' : 'Y-m-d',
      altInput: true,
      mode: 'range',
      plugins: []
    };
  }


  todaySelected()
  {
    var now = new Date();

    if (!this.enableTime)
    {
      this.dateChosen = format(now, 'yyyy-MM-dd');
    }
    else
    {
      this.dateChosen = format(now, 'yyyy-MM-dd HH:mm');
    }

    this.saveSelected();
  }


  yesterdaySelected()
  {
      var now = new Date();
      now.setDate(now.getDate()-1);

      if (!this.enableTime)
      {
        this.dateChosen = format(now, 'yyyy-MM-dd');
      }
      else
      {
        this.dateChosen = format(now, 'yyyy-MM-dd HH:mm');
      }

      this.saveSelected();
  }


  tommorowSelected()
  {
    var now = new Date();
    now.setDate(now.getDate()+1);

    if (!this.enableTime)
    {
      this.dateChosen = format(now, 'yyyy-MM-dd');
    }
    else
    {
      this.dateChosen = format(now, 'yyyy-MM-dd HH:mm');
    }

    this.saveSelected();
  }


  clearSelected()
  {
    var returnData = { date: 'clear' };
    this.modalController.dismiss(returnData, null, 'DatePickerModal');
  }


  saveSelected()
  {
    var returnData = { date: this.dateChosen };
    this.modalController.dismiss(returnData, null, 'DatePickerModal');
  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'DatePickerModal');
  }
}
